/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_TaxService_Dtos_TaxItemDto_ExportTaxItemDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_ExportTaxItemDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportResponseWrapper } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportResponseWrapper';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportSampleDownloadResponse } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportSampleDownloadResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaxItemImportService {

    /**
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemImportDownloadTaxItemImportSample(): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item-import/download-tax-item-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportResponseWrapper OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemImportImportTaxItem(
formData?: {
ImportFile: Blob;
},
): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemImportResponseWrapper> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item-import/import-tax-item',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemImportVendorTaxItemImport(
formData?: {
ImportFile: Blob;
},
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item-import/vendor-tax-item-import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemImportExportTaxItems(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_ExportTaxItemDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item-import/export-tax-items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemImportExportVendorTaxItems(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_ExportTaxItemDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item-import/export-vendor-tax-items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
